module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-1.0941c4f9.jpg";